export default "__VITE_ASSET__BOdAg6u9__"